import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share';

export class Relatorio {
    idPedidoRelatorio: number = 0;
    idPedido: number = 0;
    dsRelatorio: string = '';
    idRelatorioPB: string = '';
    idCliente: string = '';
    dtVigencia: Date = new Date();
}


export class Usuario {
    hash: string = '';
    nmUsuario: string = '';
    idUsuario: number = 0;
    lstRelatorios: Relatorio[] = [];
    nrRelatorios: number = 0;
}

@Injectable()
export class SessionService {
    public sessao: Subject<Usuario> = new Subject();
    public usuario: Usuario = new Usuario();
    public sessaoDupla: boolean = false;
    public avisoAssinatura: boolean = false;    //EGS 31.12.2020


    constructor(
        private router: Router
    ) {
        console.log('SessionService inicializado');
        // Não chama fnGetSessao() no construtor para evitar problemas de timing
    }

    fnEncerrarSessao() {
        sessionStorage.removeItem('sessao_usuario');
        this.fnGetSessao();
        window.location.href = '/home';
    }

    fnGetSessao() {
        try {
            const sessaoStr = sessionStorage.getItem('sessao_usuario');
            console.log('Carregando sessão do sessionStorage:', sessaoStr);
            if (sessaoStr) {
                const sessao = JSON.parse(sessaoStr);
                if (sessao !== null) {
                    this.usuario.hash = sessao['hash'] || '';
                    this.usuario.nmUsuario = sessao['nmUsuario'] || '';
                    this.usuario.idUsuario = sessao['idUsuario'] || 0;
                    this.usuario.lstRelatorios = sessao['lstRelatorios'] || [];
                    this.usuario.nrRelatorios = this.usuario.lstRelatorios.length;
                    console.log('Sessão carregada:', this.usuario);
                } else {
                    console.log('Sessão é null, resetando usuário');
                    this.resetUsuario();
                }
            } else {
                console.log('Nenhuma sessão encontrada no sessionStorage');
                this.resetUsuario();
            }
        } catch (error) {
            console.error('Erro ao carregar sessão:', error);
            this.resetUsuario();
        }
        this.sessao.next(this.usuario);
    }

    // Método para forçar inicialização da sessão
    fnInicializarSessao() {
        console.log('Forçando inicialização da sessão');
        this.fnGetSessao();
    }

    private resetUsuario() {
        this.usuario.hash = '';
        this.usuario.nmUsuario = '';
        this.usuario.idUsuario = 0;
        this.usuario.lstRelatorios = [];
        this.usuario.nrRelatorios = 0;
    }
    
    fnSetSessao() {
        console.log('Salvando sessão:', this.usuario);
        try {
            sessionStorage.setItem('sessao_usuario', JSON.stringify(this.usuario));
            console.log('Sessão salva no sessionStorage');
            
            // Teste: verificar se foi salvo corretamente
            const test = sessionStorage.getItem('sessao_usuario');
            console.log('Teste de leitura imediata:', test);
            
            this.sessao.next(this.usuario);
        } catch (error) {
            console.error('Erro ao salvar sessão:', error);
        }
    }
}
